import { PureComponent } from 'react';
import Dialog from '../../components/Dialog';

type Props = {
    closeMe?: (sign?: string) => void;
};

class SignaturePadDialog extends PureComponent<Props> {
    signaturePad = null;

    componentDidMount(): void {
        const wrapper = document.getElementById('signature-pad');
        const canvas = wrapper?.querySelector('canvas');

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.signaturePad = new SignaturePad(canvas, {
            // It's Necessary to use an opaque color when saving image as JPEG;
            // this option can be omitted if only saving as PNG or SVG
            backgroundColor: 'rgb(255, 255, 255)',
        });

        // function download(dataURL, filename) {
        //     const blob = dataURLToBlob(dataURL);
        //     const url = window.URL.createObjectURL(blob);

        //     const a = document.createElement('a');
        //     a.style = 'display: none';
        //     a.href = url;
        //     a.download = filename;

        //     document.body.appendChild(a);
        //     a.click();

        //     window.URL.revokeObjectURL(url);
        // }

        // One could simply use Canvas#toBlob method instead, but it's just to show
        // that it can be done using result of SignaturePad#toDataURL.
        // function dataURLToBlob(dataURL) {
        //     // Code taken from https://github.com/ebidel/filer.js
        //     const parts = dataURL.split(';base64,');
        //     const contentType = parts[0].split(':')[1];
        //     const raw = window.atob(parts[1]);
        //     const rawLength = raw.length;
        //     const uInt8Array = new Uint8Array(rawLength);

        //     for (let i = 0; i < rawLength; ++i) {
        //         uInt8Array[i] = raw.charCodeAt(i);
        //     }

        //     return new Blob([uInt8Array], { type: contentType });
        // }

        // savePNGButton.addEventListener('click', function (event) {
        //     if (signaturePad.isEmpty()) {
        //         alert('Please provide a signature first.');
        //     } else {
        //         const dataURL = signaturePad.toDataURL();
        //         download(dataURL, 'signature.png');
        //     }
        // });

        // saveJPGButton.addEventListener('click', function (event) {
        //     if (signaturePad.isEmpty()) {
        //         alert('Please provide a signature first.');
        //     } else {
        //         const dataURL = signaturePad.toDataURL('image/jpeg');
        //         download(dataURL, 'signature.jpg');
        //     }
        // });

        // saveSVGButton.addEventListener('click', function (event) {
        //     if (signaturePad.isEmpty()) {
        //         alert('Please provide a signature first.');
        //     } else {
        //         const dataURL = signaturePad.toDataURL('image/svg+xml');
        //         download(dataURL, 'signature.svg');
        //     }
        // });
    }

    onClear = (): void => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.signaturePad?.clear();
    };

    onUndo = (): void => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const data = this.signaturePad.toData();

        if (data) {
            data.pop(); // remove the last dot or line
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.signaturePad.fromData(data);
        }
    };

    onSave = (): void => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (this.signaturePad.isEmpty()) {
            alert('Please provide a signature first.');
        } else {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const dataURL = this.signaturePad.toDataURL();
            const { closeMe } = this.props;
            closeMe?.(dataURL);
        }
    };

    onClose = (): void => {
        const { closeMe } = this.props;
        closeMe?.();
    };

    render(): JSX.Element {
        return (
            <Dialog close={this.onClose}>
                <div id="signature-pad">
                    <div className="signature-pad--body">
                        <canvas></canvas>
                    </div>

                    <div
                        id="s-pad-footer"
                        className="flex items-center bg-white justify-between w-full px-16 py-12 shadow-usecase-bottom-sheet"
                    >
                        <button
                            className="px-16 py-10 secondary-btn btn"
                            type="button"
                            data-action="clear"
                            onClick={this.onClear}
                        >
                            Clear
                        </button>

                        <button
                            className="px-16 py-10 secondary-btn btn"
                            type="button"
                            data-action="undo"
                            onClick={this.onUndo}
                        >
                            Undo
                        </button>

                        <button
                            type="button"
                            className="px-16 py-10 primary-btn btn"
                            data-action="save-svg"
                            onClick={this.onSave}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default SignaturePadDialog;
